module.exports = __webpack_public_path__ + "img/btn-ladderbarrel@3x.11837080.png";